import { UserDefinedMaintenancePage } from "@/components/specific/userDefined";
import { UserDefinedItemType } from "@/types/domain";

export const ContactUserDefinedMaintenancePage = () => {
  return (
    <UserDefinedMaintenancePage
      itemType={UserDefinedItemType.Contact}
      entityType="UserDefContact"
      title="Contact User Defined Items"
      cacheKey="contact_user_defined_sort"
    />
  );
};
